import { createContext, useContext, useEffect, useState } from 'react';
import {
  onAuthStateChanged,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
} from 'firebase/auth';
import { auth } from '../firebase/firebase';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!auth) {
      setLoading(false);
      return;
    }
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  const notConfigured = () =>
    Promise.reject(new Error('Firebase is not configured. Add your credentials to .env.local.'));

  const login = (email, password) =>
    auth ? signInWithEmailAndPassword(auth, email, password) : notConfigured();

  const signup = (email, password) =>
    auth ? createUserWithEmailAndPassword(auth, email, password) : notConfigured();

  const logout = () =>
    auth ? signOut(auth) : notConfigured();

  return (
    <AuthContext.Provider value={{ currentUser, login, signup, logout }}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
